import { get } from 'lodash';
import { margin } from './css-utils';
import { messageWidth } from './message-defaults';
import { getBodyBorderWidth } from './get-body-border';
export var getMessageWidth = function (composerData, css) {
    var bodyBorderWidth = getBodyBorderWidth(composerData);
    var emailWidth = parseInt(get(css, 'so-global-body').maxWidth, 10) || messageWidth;
    var messageFullWidth = emailWidth - 2 * bodyBorderWidth;
    return messageFullWidth;
};
export function getContentWidth(composerData, css, rulesValues) {
    var margins = margin(rulesValues);
    var bodyBorderWidth = getBodyBorderWidth(composerData);
    var emailWidth = parseInt(get(css, 'so-global-body').maxWidth, 10) || messageWidth;
    var messageFullWidth = emailWidth -
        2 * bodyBorderWidth -
        (margins.left || 0) -
        (margins.right || 0);
    return messageFullWidth;
}
//# sourceMappingURL=get-message-width.js.map